import get from 'lodash/get';
import { useQuery } from '../../../tools/useQuery';
import { config } from '@uhg-abyss/web/tools/config';

import GET_PENDING_RESULTS_QUERY from './GetPendingRequests.gql';

const parseResult = (result) => {
  const initialState = {
    requests: {},
    providerRequestsFound: false,
  };

  const pendingRequestsInfo = get(result, 'digitalsecurity.pendingRequests');

  return {
    ...initialState,
    ...pendingRequestsInfo,
  };
};

export const usePendingRequestsQuery = (options) => {
  const [queryResult, queryAction] = useQuery(GET_PENDING_RESULTS_QUERY, {
    ...options,
    requestPolicy: 'no-cache',
    url: config('DIGISEC_GRAPHQL_API_URL'),
    onCompleted: (result) => {
      options.onCompleted(parseResult(result.body.data));
    },
  });
  const parsedResult = {
    ...queryResult,
    data: parseResult(queryResult.data),
  };

  return [parsedResult, queryAction];
};
